import { Button } from "@/components/_atoms/button";
import { cn } from "@/lib/cn";
import { type Column } from "@tanstack/react-table";

import { useDatatableRowCache } from "../datatable-row-cache";
import { DatatableRowData, TSectionData } from "../datatable-types";

import { useColumnDisplayValue } from "./use-column-display-value";

export function DatatableColumnToggleRow<TData extends DatatableRowData>({
  columnList,
}: {
  columnList: Column<TSectionData<TData>>[];
}) {
  const getDisplayValueForColumn = useColumnDisplayValue<TData>();
  const { resetCache } = useDatatableRowCache();

  return (
    <div className="flex flex-row flex-wrap items-center gap-1">
      {columnList.map((column) => {
        const isVisible = column.getIsVisible();

        return (
          <Button
            variant="ghost"
            size="xs"
            key={column.id}
            aria-pressed={isVisible}
            className={cn([
              "h-6 border-[0.5px] text-xs font-medium text-foreground/80",
              isVisible ? "opacity-100" : "border-[0.5px] border-transparent opacity-70",
            ])}
            onClick={() => {
              resetCache();
              column.toggleVisibility(!isVisible);
            }}
          >
            {getDisplayValueForColumn(column.id)}
          </Button>
        );
      })}
    </div>
  );
}
